import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import TickCheckbox from "../../../components/tickCheckbox";

type ModalFormatConfirmationProps = {
  handleFormatSDCard: () => void;
};

const ModalFormatConfirmation: FC<ModalFormatConfirmationProps> = ({
  handleFormatSDCard,
}) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix:
      "camera.dashboard.management.cameras.camera_details.tabs.storage",
  });
  const [isChecked, setIsChecked] = useState(false);
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );

  useEffect(() => {
    if (modalsState.showModalFormatSDCard) {
      setIsChecked(false);
    }
  }, [modalsState.showModalFormatSDCard]);
  const dispatch = useDispatch();
  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showModalFormatSDCard: false }));
  };

  const handleSubmit = () => {
    hideModal();
    handleFormatSDCard();
  };

  if (modalsState.showModalFormatSDCard === false) return null;
  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      ></div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none z-modal">
        <div className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-[480px] z-modal">
          <form
            className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl"
            onSubmit={handleSubmit}
          >
            <h2 className="col-span-6 text-3xl font-bold text-heading-black">
              {t("format_modal_heading")}
            </h2>
            <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
              {t("format_modal_sub_heading")}
            </p>
            <div className="col-span-6 flex gap-4 items-center">
              <TickCheckbox
                wrapperClass="w-10 h-10"
                id="format_sd_card"
                isChecked={isChecked}
                onClick={() => {
                  setIsChecked(!isChecked);
                }}
              />
              <label
                htmlFor="format_sd_card"
                className="text-sm leading-relaxed text-gray-500"
              >
                {t("format_modal_label")}
              </label>
            </div>
            <AdminFormFieldSubmit
              label={t("format")}
              type="button"
              variant="primary"
              onClick={handleSubmit}
              disabled={!isChecked}
            />

            <AdminFormFieldSubmit
              label={tMain("cancel")}
              type="button"
              variant="danger-transparent"
              onClick={hideModal}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalFormatConfirmation;
